import React, { FC, ReactNode } from 'react';

import { styled } from '../theme';
import FlexColumn from './FlexColumn';
import Spinner from './Spinner';
import SvgIcon from './SvgIcon';
import Tooltip from './Tooltip';

export const dropdownMenuContentStyle = {
    boxShadow:
        '0 10px 10px 0 rgba(0, 0, 0, 0.04), 0 0 10px 0 rgba(0, 0, 0, 0.08), 0 20px 20px 0 rgba(0, 0, 0, 0.06)',
    backdropFilter: 'blur(5.436563491821289px)',
};

export const DropdownMenuContent = styled(FlexColumn)({
    overflow: 'hidden',
});

export const DropdownMenuItem = styled('div')<{
    disabled?: boolean;
    isSelected?: boolean;
    isSaving?: boolean;
}>(({ theme, disabled, isSelected, isSaving }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    border: 'none',
    background: 'transparent',
    cursor: disabled || isSaving ? 'default' : 'pointer',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    color: disabled ? theme.color.disabled : theme.color.surfaceText,
    textAlign: 'left',
    width: '100%',
    boxSizing: 'border-box',
    ':hover': {
        background: disabled || isSaving ? 'transparent' : theme.color.surface,
    },
    ...(isSelected && {
        color: theme.color.green1,
    }),
    ...(isSelected &&
        disabled && {
            color: theme.color.gray40,
        }),
    ...(isSaving && {
        color: theme.color.gray40,
    }),
}));

type DropdownMenuListItemProps = {
    isSelected?: boolean;
    isSaving?: boolean;
    disabled?: boolean;
    disabledTooltip?: string;
    onClick?: (ev: React.MouseEvent) => void;
    children?: ReactNode;
};

export const DropdownMenuListItem: FC<DropdownMenuListItemProps> = ({
    isSelected,
    isSaving,
    disabled,
    disabledTooltip,
    onClick,
    children,
}) => {
    const isIndicatorShown = Boolean(isSaving || isSelected);

    const item = (
        <DropdownMenuItem
            isSelected={isSelected}
            isSaving={isSaving}
            disabled={disabled}
            onClick={!disabled && !isSaving ? onClick : undefined}
        >
            {children}
            {isIndicatorShown && (
                <div>
                    {isSaving && <Spinner />}
                    {isSelected && !isSaving && (
                        <SvgIcon
                            src="/icons/ic-status-success.svg"
                            color={(theme) => theme.color.success}
                        />
                    )}
                </div>
            )}
        </DropdownMenuItem>
    );

    if (disabled && disabledTooltip) {
        return (
            <Tooltip placement="left" title={disabledTooltip}>
                {item}
            </Tooltip>
        );
    }

    return item;
};
